import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreContext } from './context/index.js';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';
import { formatPrice } from './utils/price.js';

const EcoFee = ({ fee, locale }) => {
    const { useSelector, data: { siteConfig: { noZeroAfterDecimal = false }, }, } = useContext(CoreContext);
    const currencyCode = useSelector(selectCurrentCurrencyCode);
    const { t } = useTranslation('', { keyPrefix: '' });
    if (!(fee === null || fee === void 0 ? void 0 : fee.value) || parseFloat(fee === null || fee === void 0 ? void 0 : fee.value) <= 0 || !currencyCode) {
        return null;
    }
    return (React.createElement("div", { className: "product-config-eco-fee" },
        React.createElement("p", { className: "no-spacing font-body-small" }, t('$common.$labels.ecoFee', {
            fee: formatPrice(parseFloat(fee.value), currencyCode, locale, noZeroAfterDecimal),
        }))));
};

export { EcoFee as E };
//# sourceMappingURL=EcoFee-Ep6rIIu6.js.map
